// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ImageLargeFragmentDoc } from '../../../../imageLarge.fragment.generated';
import { QuestionnaireConditionFragmentDoc } from '../../condition/QuestionnaireCondition.fragment.generated';
export const QuestionnaireQuestionChoiceOptionContentImageConditionalFragmentDoc = gql`
    fragment questionnaireQuestionChoiceOptionContentImageConditional on QuestionnaireQuestionChoiceOptionContentImageConditional {
  image {
    ...imageLarge
  }
  conditions {
    ...questionnaireCondition
  }
}
    ${ImageLargeFragmentDoc}
${QuestionnaireConditionFragmentDoc}`;